import React, {useState} from 'react';
import {Button, Typography, Upload, Space, Divider} from 'antd';
import {CloudUploadOutlined, CloudDownloadOutlined} from '@ant-design/icons';
import ImportTestModal from "../components/import/ImportTestModal";
import ExportTestModal from "../components/import/ExportTestModal";

const {Title, Text} = Typography;

const ExportImportOverview = () => {
    const [openImportModal, setOpenImportModal] = useState(false);
    const [openExportModal, setOpenExportModal] = useState(false);


    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px'}}>
            {/* Titel */}
            <Title level={2}>Daten Export und Import</Title>
            <Text>Wählen eine der folgenden Optionen, um Daten zu exportieren oder zu importieren.</Text>

            {/* Buttons */}
            <Space direction="horizontal" size="large" style={{marginTop: '20px'}}>
                {/* Export-Button */}
                <Button
                    type="primary"
                    icon={<CloudDownloadOutlined/>}
                    size="large"
                    onClick={() => setOpenExportModal(true)}
                    style={{padding: '10px 20px'}}
                >
                    Exportieren
                </Button>

                {/* Import-Button */}
                <Button
                    type="default"
                    icon={<CloudUploadOutlined/>}
                    size="large"
                    onClick={() => setOpenImportModal(true)}
                    style={{padding: '10px 20px'}}
                >
                    Importieren
                </Button>
            </Space>

            <ImportTestModal visible={openImportModal} onClose={() => setOpenImportModal(false)}/>
            <ExportTestModal visible={openExportModal} onClose={() => setOpenExportModal(false)}/>
        </div>
    );
};

export default ExportImportOverview;
